module.exports = __webpack_public_path__ + "static/media/component3.6d2f636a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/gameRocketRepair/component3.png
// module id = 2407
// module chunks = 0